import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import sampleImage from "../../assets/Braiders/kak4.png";

const AccordionItem = ({ title, children, isOpen, onClick }) => (
  <div className="border-b border-gray-200">
    <button
      onClick={onClick}
      className="w-full text-left py-3 sm:py-4 px-4 sm:px-6 flex items-center justify-between bg-[#F3FAF9] hover:bg-[#e6f1f0] transition-colors"
      aria-expanded={isOpen}
      aria-controls={`${title.replace(/\s+/g, "-")}-content`}
    >
      <span className="uppercase text-xs sm:text-sm tracking-wide text-gray-700">
        {title}
      </span>
      {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
    </button>
    {isOpen && (
      <div
        id={`${title.replace(/\s+/g, "-")}-content`}
        className="px-4 sm:px-6 pb-4 text-gray-700 text-sm leading-relaxed"
      >
        {children}
      </div>
    )}
  </div>
);

export default function VIPBraider() {
  const [openIndex, setOpenIndex] = useState(0);
  const toggleIndex = (index) =>
    setOpenIndex((prev) => (prev === index ? null : index));

  return (
    <section className="max-w-6xl mx-auto mt-10 sm:mt-12 px-4 sm:px-6 grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10 items-start mb-16 sm:mb-20">
      {/* Image on top for mobile */}
      <div className="order-1 md:order-2 w-full">
        <img
          src={sampleImage}
          alt="VIP braider website preview"
          className="w-full h-56 sm:h-72 md:h-[500px] object-cover rounded-lg"
          loading="lazy"
        />
      </div>

      {/* Text */}
      <div className="order-2 md:order-1">
        <p className="uppercase text-xs sm:text-sm text-[#c6884a] tracking-widest mb-2">
          Skyrocket growth and maintain your business
        </p>
        <h2 className="text-2xl sm:text-3xl md:text-4xl text-gray-900 mb-3 sm:mb-4">
          VIP Website + Maintenance Plan
        </h2>
        <p className="text-gray-700 mb-6 sm:mb-8 text-sm sm:text-base">
          Stay stress‑free while your website and marketing run smoothly — we’ll handle updates, SEO, and client growth for you.
        </p>

        <div className="border border-gray-200 rounded-lg overflow-hidden shadow-sm">
          <AccordionItem
            title="What's Included"
            isOpen={openIndex === 0}
            onClick={() => toggleIndex(0)}
          >
            <ul className="list-disc list-inside space-y-1 mt-3">
              <li>Everything in the Growth & Marketing Bundle</li>
              <li>Monthly website updates (photos, pricing, new services)</li>
              <li>SEO monitoring & keyword adjustments</li>
              <li>Monthly blog or campaign updates</li>
              <li>Monthly security checks + site backups</li>
              <li>Analytics reports to track client traffic</li>
              <li>Priority support for troubleshooting</li>
            </ul>
          </AccordionItem>

          <AccordionItem
            title="Best For"
            isOpen={openIndex === 1}
            onClick={() => toggleIndex(1)}
          >
            <p className="mt-3">Ideal for established braiders running a busy salon or team.</p>
          </AccordionItem>
        </div>

        {/* CTA */}
        <div className="mt-5 sm:mt-6 flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-3">
          <p className="text-gray-700 text-base sm:text-lg">
            <span className="italic">Investment begins at:</span>{" "}
            <span className="text-xl sm:text-2xl text-gray-900 font-medium">$3,500</span>
          </p>
          <a href="/contact" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto bg-[#C18343] text-white uppercase tracking-widest px-5 sm:px-6 py-3 text-xs sm:text-sm hover:bg-[#a76e33] transition-colors rounded-md">
              Join the VIP Plan
            </button>
          </a>
        </div>
        <p className="text-xs text-gray-600 mt-2">White‑glove onboarding • Priority support • Cancel anytime</p>
      </div>
    </section>
  );
}
